var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"privilege-club"},[_c('section-header',{attrs:{"title":_vm.$t('privilege_club') + '<br/>' +  _vm.$t('for_new_residents')}}),_c('p',{staticClass:"privilege-club__text"},[_vm._v(_vm._s(_vm.$t('advantageous_offers'))+","),_c('br'),_vm._v(_vm._s(_vm.$t('discounts_promotions')))]),_c('base-button',{on:{"click":function($event){return _vm.$router.push({
        name: 'PrivilegeClub',
      })}}},[_vm._v(" "+_vm._s(_vm.$t('more_details'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }